import {addCircularTabFocus, focusElement, hookToAttributeSelector} from '@wix/panda-js-utils'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {Text} from '@wix/wix-ui-tpa/cssVars'
import {useEnvironment, useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React, {useEffect} from 'react'
import {useAppActions} from '../../../../../hooks/runtime'
import {StyledButton} from '../../styled-button'
import {classes} from '../error-modal.st.css'

export const TicketUnavailable = () => {
  const {t} = useTranslation()
  const {isMobile} = useEnvironment()
  const {refreshSeatingPlan} = useAppActions()

  useEffect(() => {
    focusElement({selector: hookToAttributeSelector(DH.MODAL_TITLE)})
    addCircularTabFocus(
      hookToAttributeSelector(DH.TICKET_UNAVAILABLE_BUTTON),
      hookToAttributeSelector(DH.TICKET_UNAVAILABLE_BUTTON),
    )
  }, [])

  return (
    <div role="dialog" aria-modal="true" className={classes.container}>
      <div className={classNames(classes.content, {[classes.desktopContent]: !isMobile})}>
        <div className={classes.text}>
          <Text
            data-hook={DH.MODAL_TITLE}
            tagName="h2"
            className={classNames(classes.title, {[classes.mobileTitle]: isMobile})}
          >
            {t('seatings_ticketUnavailableModal_title')}
          </Text>
          <Text data-hook={DH.MODAL_TEXT} tagName="p" className={classes.subtitle}>
            {t('seatings_ticketUnavailableModal_subtitle')}
          </Text>
        </div>
        <StyledButton dataHook={DH.TICKET_UNAVAILABLE_BUTTON} fullWidth={false} onClick={() => refreshSeatingPlan()}>
          {t('seatings_ticketUnavailableModal_button')}
        </StyledButton>
      </div>
    </div>
  )
}
